import {
  RETRIEVE_SEARCH_RESULTS,
  SEARCH_RESULTS_RETRIEVED,
  SET_RIM_SEARCH_PARAMETERS,
  SET_TYRE_SEARCH_PARAMETERS,
  SET_COMPLETE_WHEEL_SEARCH_PARAMETERS,
  RESET_SEARCH,
  SEARCH_ERROR,
  SET_IS_SEARCH_FORM_VALID,
  RESULTS_PER_PAGE
} from '../actions/search'
import {
  PRODUCT_RESET,
  PRODUCT_RETRIEVED
} from '../actions/product'

import { CATEGORIES } from '../helpers/categories'
import { formatCurrency, calculatePrice } from '../helpers/price'
import { RESET_WHEEL_BUILDER } from '../actions/wheelBuilder'

const getPaginationOptions = (count, currentPage) => {
  const pagination = []
  const maxPage = Math.ceil(count / RESULTS_PER_PAGE)
  const start = Math.max(1, currentPage - 3)
  const end = Math.min(start + 7, maxPage)

  pagination.push({
    text: '«',
    page: currentPage - 1,
    disabled: currentPage <= 1
  })
  for (let i = start; i <= end; i++) {
    pagination.push({
      text: i,
      page: i,
      active: currentPage === i
    })
  }
  pagination.push({
    text: '»',
    page: currentPage + 1,
    disabled: currentPage >= maxPage
  })
  return pagination
}

const mapProducts = (products) => {
  return products.map(product => {
    if (!product.stock) {
      product.estimatedDeliveryType = 0;
    } else {
      let deliv = product.deliveryTime;
      if (!deliv) {
        if (product.source === 'stock') {
          deliv = { min: 1, max: 1, 'class': 1 };
        } else {
          deliv = { min: 3, max: 5, 'class': 2 };
        }
      }
      product.deliveryTime = deliv
      product.estimatedDeliveryType = deliv['class'];
    }

    product.formattedPrice = formatCurrency(product.price)
    product.formattedPriceInclVat = calculatePrice(product.price, 1, product.vatPercent)
    product.slug = product.brand ? `${product.brand.name} ` : ''
    product.slug = `${product.slug}${product.name}`
      .toLowerCase()
      .replace(/[åä]/, 'a')
      .replace('ö', 'o')
      .replace(/[^\w\d\s]*/g, '')
      .replace(/\s+/g, '-')

    if (product.rear) {
      const { rear } = product
      if (!rear.stock) {
        rear.estimatedDeliveryType = 0;
      } else {
        let deliv = rear.deliveryTime;
        if (!deliv) {
          if (rear.source === 'stock') {
            deliv = { min: 1, max: 1, 'class': 1 };
          } else {
            deliv = { min: 3, max: 5, 'class': 2 };
          }
        }
        rear.deliveryTime = deliv
        rear.estimatedDeliveryType = deliv['class'];
      }

      rear.formattedPrice = formatCurrency(rear.price)
      rear.formattedPriceInclVat = calculatePrice(rear.price, 1, rear.vatPercent)
      rear.slug = rear.brand ? `${rear.brand.name} ` : ''
      rear.slug = `${rear.slug}${rear.name}`
        .toLowerCase()
        .replace(/[åä]/, 'a')
        .replace('ö', 'o')
        .replace(/[^\w\d\s]*/g, '')
        .replace(/\s+/g, '-')
      product.rear = rear
    }
    return product
  })
}

const resetResultsByCategory = () => {
  const resultsByCategory = {}
  Object.keys(CATEGORIES).forEach(key => {
    resultsByCategory[CATEGORIES[key].id] = { products: [], pagination: [] }
  })
  return resultsByCategory
}

const getInitialState = () => {
  return {
    isFormValid: true,
    resultsByCategory: {
      completeWheel: {products: [], pagination: [], searchMode: null },
      tyre: {products: [], pagination: [], searchMode: null },
      rim: {products: [], pagination: [], searchMode: null }
    },
    activeProduct: null,
    error: ''
  }
}

const search = (state = getInitialState(), action) => {
    switch (action.type) {
      case SET_IS_SEARCH_FORM_VALID:
        return { ...state, isFormValid: action.isFormValid }
      case RESET_SEARCH:
        return getInitialState()
      case SET_TYRE_SEARCH_PARAMETERS:
      case SET_RIM_SEARCH_PARAMETERS:
      case SET_COMPLETE_WHEEL_SEARCH_PARAMETERS:
        let resultsByCategory = resetResultsByCategory()
        resultsByCategory[action.category.id] = Object.assign({}, resultsByCategory[action.category.id], {
          searchParamsInitialized: true,
          initialSearchDone: false,
          searchMode: action.parameters.searchMode
        })
        return Object.assign({},
          state,
          {
            resultsByCategory
          }
        )
      case RETRIEVE_SEARCH_RESULTS:
        resultsByCategory = Object.assign({}, state.resultsByCategory)
        resultsByCategory[action.category.id] = Object.assign({}, resultsByCategory[action.category.id], {
          isLoading: true
        })
        return Object.assign({},
          state,
          {
            resultsByCategory,
            error: ''
          }
        )
      case SEARCH_RESULTS_RETRIEVED: {
        const isPair = !!(action.criteria && action.criteria.isPair)

        let isStaggeredFitment = isPair
        const { criteria } = action
        // TODO: Return from API instead?
        // TODO: Helper and better typecheck when object properties are incomplete

        if (criteria) {
          const loadIndexFront = Array.isArray(criteria.load_index) ? criteria.load_index[0] : criteria.load_index
          const loadIndexRear = Array.isArray(criteria.load_index_rear) ? criteria.load_index_rear[0] : criteria.load_index_rear
          if (
            isPair && criteria.tyre_dimensions && criteria.tyre_dimensions_rear &&
            criteria.tyre_dimensions[0][0] === criteria.tyre_dimensions_rear[0][0] &&
            criteria.tyre_dimensions[0][1] === criteria.tyre_dimensions_rear[0][1] &&
            criteria.tyre_dimensions[0][2] === criteria.tyre_dimensions_rear[0][2] &&
            (
              (!criteria.load_index && !criteria.load_index_rear) ||
              (loadIndexFront === loadIndexRear)
            )
          ) {
            isStaggeredFitment = false
          }
        }

        resultsByCategory = Object.assign({}, state.resultsByCategory)
        resultsByCategory[action.category.id] = Object.assign({}, resultsByCategory[action.category.id], {
          initialSearchDone: true,
          isLoading: false,
          products: mapProducts(action.products),
          sortBy: action.sortBy,
          isStaggeredFitment,
          isPair,
          // products: mapProducts(COMPLETE_WHEEL_SEARCH_RESPONSE.data.products),
          pagination:  getPaginationOptions(action.count, action.page),
          count: action.count
        })
        return Object.assign({},
          state,
          {
            resultsByCategory
          }
        )
      }
      case SEARCH_ERROR:
        resultsByCategory = Object.assign({}, state.resultsByCategory)
        resultsByCategory[action.category.id] = Object.assign({}, resultsByCategory[action.category.id], {
          initialSearchDone: true,
          isLoading: false,
          products: [],
          pagination:  getPaginationOptions(0, 1),
          count: 0
        })
        return Object.assign({},
          state,
          {
            resultsByCategory,
            error: action.error
          }
        )

      case PRODUCT_RETRIEVED:
        return { ...state, activeProduct: mapProducts(action.product)[0] }
      case PRODUCT_RESET:
        return { ...state, activeProduct: null }
      case RESET_WHEEL_BUILDER:
        return { ...state, ...getInitialState() }
      default:
        return state
  }
}

export default search
